// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { ICampaignConfigFieldData } from '@app/core/models/core-models';
import { TrafficSourcesService } from '@services/traffic-sources/traffic-sources.service';
import { ICreateTrafficSourceData } from '@app/core/services/traffic-sources/traffic-sources.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailsSectionState } from './details-section/details-section.component';

export interface CurrentModalSetting {
  id: number;
  fields: ICampaignConfigFieldData[];
  children: ICreateTrafficSourceData[];
  trafficSourceId?: number;
}
interface ITrafficSourceData {
  id: number;
  type: number;
}
@Component({
  selector: 'app-add-traffic-source-modal',
  templateUrl: './add-traffic-source-modal.component.html',
  styleUrls: ['./add-traffic-source-modal.component.scss']
})
export class AddTrafficSourceModalComponent implements OnInit {
  @Input() public trafficSourceData?: ITrafficSourceData;

  @Input() forceSummaryMode = false;
  @Input() token: string = '';
  @Input() trafficSourceIdInput?: number;
  @Input() url: string = '';

  public isLoaded = false;
  private mode = {
    selectType: 'selectType',
    details: 'details',
    summary: 'summary'
  };
  public currentMode = 'selectType';
  public modalSettings: ICreateTrafficSourceData[] = [];
  public currentModalSetting?: CurrentModalSetting;
  public verificationToken = '';
  public trafficSourceId: number | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly trafficSourceService: TrafficSourcesService
  ) {}

  ngOnInit(): void {
    if (this.forceSummaryMode && this.token && this.trafficSourceIdInput) {
      this.onSetComponentState({ summaryMode: true, token: this.token, traffic_source_id: this.trafficSourceIdInput, isLoaded: true });

      return;
    }

    if (this.trafficSourceData) {
      this.trafficSourceService.getDatOfTrafficSourceToEdit(this.trafficSourceData.id).subscribe(({ status_code, data }) => {
        this.currentMode = this.mode.details;

        if (status_code === 200 && data?.traffic_source && this.trafficSourceData) {
          const setting = data.traffic_source;
          this.currentModalSetting = { id: this.trafficSourceData.type, fields: setting.fields ?? [], children: [], trafficSourceId: setting.id ?? 0 };
        }
        this.isLoaded = true;
      });
    } else {
      this.trafficSourceService.getModalConfig().subscribe(({ data, status_code }) => {
        if (status_code === 200 && data?.traffic_sources) {
          this.modalSettings = data.traffic_sources;
        }
        this.isLoaded = true;
      });
    }
  }

  public onSelectType($event: { id: number } | null): void {
    if ($event !== null) {
      this.currentMode = this.mode.details;
      // element with id = 34 is the last element in modalSettingsArray (modalSettings[8].id == 34)
      const index = $event.id === 34 ? 8 : $event.id - 1;
      const setting = this.modalSettings?.[index];
      if (setting) {
        this.currentModalSetting = { id: setting.id!, fields: setting.fields ?? [], children: setting.children ?? [] };
      }
    } else {
      this.currentModalSetting = undefined;
    }
  }

  public onSetComponentState(state: DetailsSectionState): void {
    if (state.summaryMode && state.token && state.traffic_source_id) {
      this.verificationToken = state.token;
      this.trafficSourceId = state.traffic_source_id;
      this.currentMode = this.mode.summary;
      if (state.setUrl) {
        this.url = state.setUrl;
      }
    }
    this.isLoaded = state.isLoaded;
  }

  public closeModal(): void {
    this.activeModal.close();
  }
}
